import Home from "./Components/Home/Home";
import MemberShip from "./Components/Membership";
import TrainingAndResources from "./Components/Training&Resources/Training&Resources";
import NewsAndUpdates from "./Components/News&Updates/News&Updates";
// import Events from './Components/Events/Events';
import ContactForm from "./Components/ContactUs";
import WhoWeAre from "./Components/AboutUs/whoWeAre";
import Objectives from "./Components/AboutUs/objectives";
import Empowers from "./Components/AboutUs/empowers";
import Commitees from "./Components/AboutUs/commitees";
import ApcciBoard from "./Components/AboutUs/apcciBoard";
import OrganisingTeam from "./Components/AboutUs/organisingteam"; 
import EventDetails from "./Components/Events/EventsDetails";
import TermsConditions from "./Components/PublicPages/Terms&Conditions";
import PrivacyPolicy from "./Components/PublicPages/PrivacyPolicy";
import Refund from "./Components/PublicPages/Refund";
import Individual from "./Components/Membership/MembershipForms/Individual ";
import Life from "./Components/Membership/MembershipForms/life";
import Organisational from "./Components/Membership/MembershipForms/Organisational";
import MembershipBenefits from "./Components/Membership/membershipBenifits";
import HowToJoin from "./Components/Membership/howToJoin";
import MemberDirectory from "./Components/Membership/memberDirectory";
import UpcomingEvents from "./Components/Events/UpcomingEvents";
import PastEvents from "./Components/Events/PastEvents";
import Governance from "./Components/AboutUs/governance";
import Career from "./Components/CareerUs";

export const PublicRoutes = [
  { path: "/", component: Home },
  { path: "/about/whoweare", component: WhoWeAre },
  { path: "/about/objectives", component: Objectives },
  { path: "/about/how-we-empowers-you", component: Empowers },
  { path: "/about/governance-structure", component: Governance },
  { path: "/our-committee", component: Commitees },
  { path: "/about/organising-team", component: OrganisingTeam },
  { path: "/our-board", component: ApcciBoard },
  { path: "/membership/plans", component: MemberShip },
  { path: "/training-resources", component: TrainingAndResources },
  { path: "/news-updates", component: NewsAndUpdates },
  // { path: '/event', component: Events },
  { path: "/event/:eventId", component: EventDetails },
  { path: "/event/upcoming", component: UpcomingEvents }, // Keep for backward compatibility
  { path: "/event/past", component: PastEvents }, // Keep for backward compatibility
  { path: "/events/upcoming-events", component: UpcomingEvents },
  { path: "/events/past-events", component: PastEvents },
  { path: "/terms-conditions", component: TermsConditions },
  { path: "/privacy-policy", component: PrivacyPolicy },
  { path: "/refund", component: Refund },
  { path: "/contact-us", component: ContactForm },

{ path: '/career-with-us', component: Career },
  { path: "/membership/individual-membership-form", component: Individual },
  { path: "/membership/life-membership-form", component: Life },
  {
    path: "/membership/organisational-membership-form",
    component: Organisational,
  },
  { path: "/membership/why-join", component: Empowers },
  { path: "/membership/how-to-join", component: HowToJoin },
  { path: "/membership/member-directory", component: MemberDirectory },
  { path: "/events/upcoming-events", component: UpcomingEvents },
  { path: "/events/past-events", component: PastEvents },
];
